import { IconSet } from '@postscript/components';
import {
  DATA_LABS,
  ENTITLEMENTS_ADMIN_UI,
  USAGE_BILLING_ENABLED,
} from 'components/admin/utils/feature-flags';
import { useMemo } from 'react';
import { NavMenuItem } from '../NavMenu';

export const useAdminMenuItems = (): NavMenuItem[] => {
  return useMemo(
    () => [
      {
        id: 'admin',
        label: 'Postscript Admin',
        icon: IconSet.Key,
        isLoading: false,
        ariaLabelledBy: 'nav-admin-title',
        subMenu: [
          {
            link: '/account-overview',
            label: 'Account Overview',
            id: 'admin-account-overview',
          },
          {
            link: '/ai-configuration',
            label: 'AI Configuration',
            id: 'admin-ai-configuration',
          },
          {
            link: '/admin/templates',
            label: 'Templates',
            id: 'admin-templates',
          },
          {
            link: '/admin/billing',
            label: 'Billing',
            id: 'admin-billing',
            featureFlag: USAGE_BILLING_ENABLED,
            featureFlagOptOut: true,
          },
          {
            link: '/admin/messaging-status',
            label: 'Messaging',
            id: 'admin-messaging',
          },
          {
            link: '/admin/announcements',
            label: 'Service Announcements',
            id: 'admin-announcements',
          },
          {
            link: '/admin/ps-labs',
            label: 'PS Labs',
            id: 'admin-ps-labs',
          },
          {
            link: '/admin/partners',
            label: 'Partners',
            id: 'admin-partners',
          },
          {
            link: '/admin/data-labs',
            label: 'Data Labs',
            id: 'data-labs',
            labsFeatureFlag: DATA_LABS,
          },
          {
            link: '/omni',
            label: 'Omni Sandbox',
            id: 'omni',
          },
          {
            link: '/admin/list-management',
            label: 'List Management',
            id: 'admin-list-management',
          },
          {
            link: '/admin/entitlements',
            label: 'Entitlements',
            id: 'admin-entitlements',
            labsFeatureFlag: ENTITLEMENTS_ADMIN_UI,
          },
        ],
      },
    ],
    [],
  );
};
